import { css, Global } from "@emotion/react";
import { DATA_EXPORT_ID } from "./DashboardChart";
import { STATUS_SUMMARY_EXPORT_ID } from "./StatusSummary";

const printStyles = css`
  @media print {
    /* Hide app chrome */
    header,
    nav {
      display: none !important;
    }

    /* Hide interactive controls */
    [data-print-hide] {
      display: none !important;
    }

    /* Reset viewport constraints so content flows for print */
    html,
    body,
    #root {
      height: auto !important;
      overflow: visible !important;
    }

    body {
      background: white !important;
    }

    /* Override the BaseLayout grid to remove sidebar column */
    body * {
      overflow: visible !important;
    }

    main {
      padding: 0 !important;
    }

    /* Preserve chart colors in print */
    * {
      print-color-adjust: exact !important;
      -webkit-print-color-adjust: exact !important;
    }

    /* Prevent page breaks inside dashboard chart cards */
    main [${DATA_EXPORT_ID}]:not([${DATA_EXPORT_ID}="${STATUS_SUMMARY_EXPORT_ID}"]) {
      break-inside: avoid;
    }

    /* Hide chart tooltips and hover overlays */
    .recharts-tooltip-wrapper,
    .chakra-tooltip,
    [role="tooltip"] {
      display: none !important;
    }

    /* Remove box shadows for cleaner print */
    [class*="css-"] {
      box-shadow: none !important;
    }
  }
`;

export const DashboardPrintStyles = () => <Global styles={printStyles} />;
